@if (readiness(); as r) {
  <div class="rdy">
    <button
      class="rdy__pill"
      [class.rdy__pill--done]="r.score === r.total"
      (click)="open.set(!open())"
      title="Readiness checklist"
    >
      <span class="rdy__bar">
        <span
          class="rdy__bar-fill"
          [class.rdy__bar-fill--done]="r.score === r.total"
          [style.width.%]="(r.score / r.total) * 100"
        ></span>
      </span>
      Ready {{ r.score }}/{{ r.total }}
      <wg-icon name="chevron-down" [size]="12" [style.transform]="open() ? 'rotate(180deg)' : 'none'" />
    </button>

    @if (open()) {
      <div class="card fade-up rdy__pop">
        <div class="rdy__pop-label">Readiness coach</div>
        @for (item of r.items; track item.label) {
          <button
            class="rdy__item"
            [class.rdy__item--link]="!item.ok && !!item.section"
            [disabled]="item.ok || !item.section"
            (click)="onItem(item.section)"
          >
            <span class="rdy__item-state" [class.rdy__item-state--ok]="item.ok">
              @if (item.ok) {
                <wg-icon name="check" [size]="12" [strokeWidth]="2.4" />
              }
            </span>
            <span class="rdy__item-label" [class.rdy__item-label--ok]="item.ok">{{ item.label }}</span>
            @if (!item.ok && item.section) {
              <wg-icon name="chevron-right" [size]="12" class="rdy__item-go" />
            }
          </button>
        }
        @if (r.score === r.total) {
          <div class="rdy__done-note">All set — submit when you're happy with the test answers.</div>
        }
      </div>
    }
  </div>
}
